import { cn } from '@commenda/utils';
import React from 'react';

interface ITextInput<T> {
  id: string;
  placeholder?: string;
  value: T;
  type: 'text' | 'number' | 'password' | 'email' | 'date' | 'tel' | 'url';
  setValue?: React.Dispatch<React.SetStateAction<T>>;
  disabled?: boolean;
  max?: string | number;
  name?: string;
  className?: string;
}

const TextInput = <T extends string | number>({
  id,
  placeholder = '',
  value,
  setValue = () => {},
  type,
  disabled = false,
  max,
  name,
  className = '',
}: ITextInput<T>) => {
  return (
    <input
      type={type}
      name={name || id}
      id={id}
      placeholder={placeholder}
      className={cn(
        'px-3 py-2 w-full block rounded-md border border-[#E8E8E8] focus:outline-none focus:ring-1 focus:ring-0 focus:ring-offset-0 sm:text-sm placeholder-gray disabled:bg-gray-100',
        className
      )}
      value={value}
      onChange={(e) => setValue(e.target.value as T)}
      disabled={disabled}
      {...(max ? { max } : {})}
    />
  );
};

export default TextInput;
